// Who a social post will tag, worked out the same way the post generator does.

const HANDLE_KEYS = ["instagram_handle", "facebook_handle", "twitter_handle", "tiktok_handle"];

const clean = (v) => String(v || "").trim();

export const hasHandle = (thing) => HANDLE_KEYS.some((k) => clean(thing?.[k]));

// The musicians on a gig: the performing line-up on a band gig when one is set,
// otherwise everyone attached to the gig. Mirrors the backend post generator.
export function gigMusicianIds(gig) {
  if (!gig) return [];
  const performing = gig.performing_member_ids || [];
  return gig.band_id && performing.length ? performing : gig.collaborator_ids || [];
}

// { total, tagged, missing: [names without a handle] } for the musicians on a gig.
export function summariseMusicianTags(gig, collaborators) {
  const byId = new Map((collaborators || []).map((c) => [c.collaborator_id, c]));
  const people = gigMusicianIds(gig).map((id) => byId.get(id)).filter(Boolean);
  const tagged = people.filter(hasHandle);
  return {
    total: people.length,
    tagged: tagged.length,
    missing: people.filter((p) => !hasHandle(p)).map((p) => p.name),
  };
}

const withAt = (h) => (clean(h).startsWith("@") ? clean(h) : `@${clean(h)}`);

// The venue's saved handles as readable pieces, e.g. [{platform:"Instagram", handle:"@theritz"}].
export function venueHandleList(venue) {
  const out = [];
  if (clean(venue?.instagram_handle)) out.push({ platform: "Instagram", handle: withAt(venue.instagram_handle) });
  if (clean(venue?.twitter_handle)) out.push({ platform: "X", handle: withAt(venue.twitter_handle) });
  if (clean(venue?.facebook_handle)) out.push({ platform: "Facebook", handle: clean(venue.facebook_handle) });
  return out;
}
